import { Row } from 'reactstrap';

import Pims from './Pims';
import SyncDate from './SyncDate';
import InstanceId from './InstanceId';
import ConfigHeader from './ConfigHeader';
import AssignmentAndMute from './AssignmentAndMute';
import PracticeOfferings from './PracticeOfferings';
import FriendlyId from './FriendlyId';

const PracticeConfiguration = () => {
    return (
        <Row>
            <ConfigHeader />
            <InstanceId />
            <FriendlyId />
            <Pims />
            <SyncDate />
            <AssignmentAndMute />
            <PracticeOfferings />
        </Row>
    );
};

export default PracticeConfiguration;
